// Studio Workspace Inc 1 — go-live now lives on the Studio dashboard; this legacy
// path redirects there.
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/live')({
  beforeLoad: () => {
    throw redirect({ to: '/admin/studio' });
  },
});
